// extracted by mini-css-extract-plugin
export var active = "_bj-7";
export var container = "_bj-0";
export var evenWidth = "_bj-4";
export var large = "_bj-5";
export var outlet = "_bj-8";
export var slide = "_bj-2";
export var small = "_bj-6";
export var tab = "_bj-3";
export var tabs = "_bj-1";